module.exports = __webpack_public_path__ + "img/product-1-details.afeea0fa.jpg";